import React, { useEffect, useState } from 'react'

import { useWatchableRef } from 'lib/hooks'
import { updateRequesterEmailApi } from './api'

export default function UpdateRequesterEmailModal({
  open,
  onClose,
  building,
  requester,
  document_id,
  updateLocalRequesterEmail,
}) {
  const [email, setEmail] = useState('')

  const modalRef = useWatchableRef(null)

  useEffect(() => {
    if (!modalRef.current) return

    if (open) {
      $(modalRef.current).modal('show')
    } else {
      $(modalRef.current).modal('hide')
    }
  }, [open, modalRef.version])

  useEffect(() => {
    if (!modalRef.current) return

    const localRefValue = modalRef.current
    const handleClose = (_e) => onClose()

    $(localRefValue).on('hidden.bs.modal', handleClose)
    return () => $(localRefValue).off('hidden.bs.modal', handleClose)
  }, [onClose, modalRef.version])

  const handleSubmit = (e) => {
    e.preventDefault()
    const formData = new FormData(e.target)
    const data = Object.fromEntries(formData.entries())
    onSubmit(data)
  }

  const onSubmit = async (payload) => {
    const params = {
      document_request_id: document_id,
      document_request: payload,
    }
    try {
      const response = await updateRequesterEmailApi(params)
      updateLocalRequesterEmail(response.data.email)
      $(modalRef.current).modal('hide')
      onClose()
    } catch (error) {
      alert(error.message)
    }
  }

  return (
    <>
      <div className="modal" tabIndex="-1" role="dialog" ref={modalRef.ref}>
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header text-center">
              <h2 className="modal-title text-dark">Update Requester Email</h2>
            </div>
            <div className="modal-body w-100">
              <h4 className="modal-title text-danger text-center p-5 m-5">
                This email is being used to send Document Request link.
              </h4>
              <form onSubmit={handleSubmit} id="board-minutes-update-requester-email-form">
                <table className="table table-borderless">
                  <thead className="table-dark">
                    <tr>
                      <th style={{ color: '#404040' }}>Review Credentials</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{requester.name}</td>
                      <td>{building.title}</td>
                    </tr>
                    <tr>
                      <td>{requester.email}</td>
                      <td>
                        {building.address}, Unit: {requester.unit}
                      </td>
                    </tr>
                    <tr>
                      <td className="text-danger">{requester.phone}</td>
                      <td>
                        {building.city}, {building.state}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div className="input-section">
                  <div>
                    New Email<span className="text-danger">*</span>
                  </div>
                  <input
                    type="text"
                    name="email"
                    onChange={(e) => {
                      setEmail(e.target.value)
                    }}
                  />
                </div>
              </form>
            </div>
            <div className="modal-footer">
              <button type="button" className="btn btn-secondary pull-left" data-dismiss="modal">
                Close
              </button>
              <button
                type="submit"
                form="board-minutes-update-requester-email-form"
                className="btn btn-success pull-right"
                disabled={!email}
              >
                Update Email
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
